$(document).ready(function(){
  $(".footer__copyright").html('<small class="copyright__content">© 2023, <a href="/" title="">Vliving</a></small>');
   $(".gm-grid").next("p").remove();
   //setTimeout(function() {
     // $(".w-vendor__logo").remove();
   // }, 5000);
  
});